
import { Component, Mixins } from "vue-property-decorator";
import { IObjectControllableFeature, ILinkedPageObjectSpecifiable } from "../../../../../../documaker/domain/format/objects";
import { ITranscribeDateOfTimeBehaviorPropertyEditable, instanceOfITranscribeDateOfTimeBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TranscribeDateOfTimeBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITranscribeDateOfTimeBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITranscribeDateOfTimeBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTranscribeDateOfTimeBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITranscribeDateOfTimeBehaviorPropertyEditable(s) && s.transcribeDateOfTimeBehavior().isEditable(), false);
  }

  get transcribeDateOfTimeBehavior(): IObjectControllableFeature<ILinkedPageObjectSpecifiable> {
    return this.readPropertyOrDefault(s => s.transcribeDateOfTimeBehavior().getValue(), { target: null, isEnable: false });
  }

  set transcribeDateOfTimeBehavior(value: IObjectControllableFeature<ILinkedPageObjectSpecifiable>) {
    this.writePropertyWhenValid(s => s.transcribeDateOfTimeBehavior().setValue(value));
  }
}
